<script>
import appConfig from '@src/app.config'
import chat from '@mixins/chat'

export default {
  mixins: [chat],
  page() {
    const scripts = []
    // Conditionally include scripts in production
    if (process.env.NODE_ENV === 'production') {
      scripts.push(
          {
            src: 'https://www.googletagmanager.com/gtag/js?id=G-HPM50ZRLTD',
            async: true,
          },
          {
            src: '/js/ga.js',
            async: true,
          },
      )
    }
    return {
      // All subcomponent titles will be injected into this template.
      titleTemplate(title) {
        title = typeof title === 'function' ? title(this.$store) : title
        return title ? `${title} · ${appConfig.title}` : appConfig.title
      },
      script: scripts,
      link: [
        { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: true },
      ],
    }
  },
  beforeCreate() {
    window.Onvocado = {}
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath"/>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/
@import '../src/assets/sass/app';

#nprogress .bar {
  background: $color-text-secondary;
}
</style>
